export const SHORT_TASK_XY = [
    {
        id: 1,
        type: '選擇題',
        text: '1.<br/>「生茄子嘗起來就像一顆平淡無味的蘋果，但一經烹調，便搖身變為可口無比的珍饈。酥炸過的茄子會散發美妙的奶油香味，灑些甜中帶辣的香料，風味絕佳。無論是燉煮或烘烤，茄子那種菇蕈般的麝香氣味，都能與鹹味食材完美搭配。除了偷偷咬一小口的方式外，檢查茄子是否具有所需風味與質地最好的方法，就是測試它的緊實度。一顆理想的茄子，外觀應該要像海豚皮膚般緊實光亮，用手揉捏時，還會發出嘎吱嘎吱的聲響。」',
        question: '根據本文，下列關於茄子的風味介紹，何者在文中沒有被提及？',
        options: [
            { text: 'A. 食用口感', },
            { text: 'B. 調味搭配', },
            { text: 'C. 適用醬汁', correct: true },
            { text: 'D. 測試方式', },
        ],
        background: '#F8FAFB',
    }, {
        id: 2,
        type: '選擇題',
        text: '2.<br/>「每個人都會在人世中遭遇一些坎坷，我們的身心都可能傷痕累累，但，那也是我們學習的功課。」',
        question: '作者這段文字的意義最接近下列何者?',
        options: [
            { text: 'A. 因為人世中總會遇到一些坎坷，所以身心受創是無法避免的。', },
            { text: 'B. 唯有精進學業，才能以堅毅的心迎戰人世中不可預期的坎坷。', },
            { text: 'C. 雖然人生的坎坷境遇會打擊我們，卻也是我們要面對的挑戰。', correct: true },
            { text: 'D. 即便作好萬全準備，遭遇坎坷時仍會給身心帶來巨大的傷害。', },
        ],
        background: '#F8FAFB'

    }, {
        id: 3,
        type: '選擇題',
        text: '3.<br/>「一個項目成功與否，有 60%以上的因素取決於是否能以數行到一頁之間的長度陳述其核心想法，這也是所有業界人士是否願意青睞，考慮要不要繼續看下去的關鍵。」',
        question: '根據本段文字，推論業界人士最需要的是哪一項能力？',
        options: [
            { text: 'A. 高效搜集和整理大量資料的技巧' },
            { text: 'B. 簡潔與精準表達中心觀點的能力', correct: true },
            { text: 'C. 快速撰寫與解讀長篇文章的技能' },
            { text: 'D. 具備創意思維和問題解決的能力' },
        ],
        background: '#F8FAFB'
    }, {
        id: 4,
        type: '選擇題',
        text: '4.<br/>「王先生是一位享譽國際的畫家，正忙著準備今天的演講稿。去年，他再度榮獲世界繪畫大獎，讓他躍上了事業巔峰。其實，他並非從小就展現繪畫天分，他曾在課堂上多次被老師訓斥。想起那段往事後，王先生微微一笑，拿起筆，繼續修改眼前的講稿。」',
        question: '關於這段文字的寫作結構，下列分析何者正確?',
        options: [
            { text: 'A. 全文依照時間發生的先後，一步步交代王先生的奮鬥過程。' },
            { text: 'B. 採用倒敘法，先寫王先生事業成功，再說明他成名的原因。' },
            { text: 'C. 文末補充王先生微微一笑，是為了讓讀者掌握主角的心境，屬補敘法。' },
            { text: 'D. 在敘述當下準備演講的過程中，暫時切入小時候的往事，屬於插敘法。', correct: true }
        ],
        background: '#F8FAFB'
    },
     {
        id: 5,
        type: '選擇題',
        text: '5.<br/>「購買航海圖的委託人可選擇諸多裝飾性元素，再由製圖師或是在製圖師工作坊裡任職的專業藝術家繪製在底圖上。這些可供選擇的裝飾元素包括手繪城市圖像、象徵城市政治掌權者的旗幟、羅盤方位圖，以及山脈、河流、船隻等圖案，還有若干地圖中出現的海怪。這類航海圖更為精緻，因而更為昂貴──滿是裝飾性元素的航海圖甚至比實用性的航海圖貴上十倍──其並非用於導航，而是供王室和貴族收藏、展示之用。」',
        question: '根據這段文字，下列關於繪有海怪圖像航海圖的敘述何者正確？',
        options: [
            { text: 'A.	裝飾元素由製圖師決定', },
            { text: 'B.	清楚標示海怪所在位置', },
            { text: 'C.	作品絕多數為船長擁有 ', },
            { text: 'D.	該圖無法於航行中使用', correct: true },
        ],
        background: '#F8FAFB'
    }, {
        id: 6,
        type: '選擇題',
        text: '6.<br/>「好的圍棋要慢慢地下，好的生活歷程要細細品味；不要著急把棋盤下滿，也不要匆忙的走人生之路。」',
        question: '上述語句內容所要表達的意思為何?',
        options: [
            { text: 'A. 人生短暫，宜好好生活，不要心急。', correct: true },
            { text: 'B. 圍棋比賽時，可以慢慢想如何下子。', },
            { text: 'C. 人生就如下棋般，須思考如何行事。', },
            { text: 'D. 下圍棋時，應考量棋子的空間分佈。', },
        ],
        background: '#F8FAFB'

    }, {
        id: 7,
        type: '選擇題',
        text: '7.<br/>小丸子在網上看到一則帖文：「打開薯片才發現，原來空氣也是需要錢的！」',
        question: '這句話想要表達的涵義最有可能是什麼？',
        options: [
            { text: 'A. 袋內注入氣體，有助於維持食物的品質，所以空氣也算成本。' },
            { text: 'B. 諷刺產品內容物太少，包裝內充飽的氣體反而讓人覺得無言。', correct: true },
            { text: 'C. 打開袋子，薯片的香氣撲鼻而來，是零食包裝設計的巧思。' },
            { text: 'D. 從購入的薯片中，找到不肖商家品質管控不良的充分證據。' },
        ],
         background: '#F8FAFB'
    }, {
        id: 8,
        type: '選擇題',
        text: '8.<br/>「近年，法國鄉村出現很多乍看之下匪夷所思的爭議，新搬來的居民受不了鄉村常見的雞啼、蟬鳴等聲音，將他們的鄰居一狀告上法院，不僅讓老住戶被告得一頭霧水，更讓許多法國民眾開始思考起法國鄉村真正的樣貌。是以近日法國參議院通過一部法案，正式認可鄉村常聽見的雞啼、蛙鳴等聲音，都是法國鄉村『感官遺產』的一部分，未來也都在法國法律的保障範圍內，希望能藉此解決多年來都市民眾和鄉村居民間的爭議。」',
        question: '這段報導內容運用了何種寫作方式？',
        options: [
            { text: 'A. 先因後果', correct: true },
            { text: 'B. 先總後分', },
            { text: 'C. 觀點對比', },
            { text: 'D. 歸納論證', }
        ],
        background: '#F8FAFB'
    }
]